import React from 'react';
import { Wrapper } from './paper.styles';

const Paper: React.FC = ({ children, ...rest }) => {
    return <Wrapper {...rest}>{children}</Wrapper>;
};

export default Paper;
